
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bimbel/user/weekly_schedule",
      function () {
        return require("private-next-pages/bimbel/user/weekly_schedule.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bimbel/user/weekly_schedule"])
      });
    }
  